class HospitalityTaystForm {
  constructor() {
    this.init();
  }
  init() {
    this.getCountryList();
    this.formEvents(this);
  }
  getCountryList(){
    fetch(tayst.geoData)
    .then(response => response.json())
    .then(response => {
      if (!cn(response)) {
        const countryDrop = document.getElementById("country_list");
        for (let i = 1; i < response.length; i++) {
          const currCountry = response[i];
          if (!cn(currCountry)) {
            const option = document.createElement("option");
            option.value = currCountry.name;
            option.dataset.iso = currCountry.iso3;
            option.dataset.phonemin = currCountry.min_length;
            option.dataset.phonemax = currCountry.max_length;
            option.dataset.hasstates = currCountry.show_states;
            option.textContent = currCountry.name;
            if (currCountry.iso3 == "USA") {
              option.selected = true;
            }
            countryDrop.appendChild(option);
          }
        }
        countryDrop.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        alert("Something went wrong! Refresh the page or reach out for assistance.");
      }
    })
    .catch(() => {
      alert("Something went wrong! Refresh the page or reach out for assistance.");
    });
  }
  formEvents(){
    document.getElementById("phone").addEventListener("input", function (e) {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    });
    document.getElementById("number_of_rooms").addEventListener("input", function (e) {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    });
    document.addEventListener("submit", function(e) {
      if(e.target.matches("#hosp-tayst-form")){
        e.preventDefault();
        const btnForm = e.target;
        const hubspotUrl = tayst.hubspotContact;
        let checkboxValues = "";
        const phoneNum = btnForm.querySelector("[name=phone]");
        const machineCheck = btnForm.querySelectorAll(".hosp-tayst-field[type=checkbox]:checked");
        const countrySelect = document.getElementById("country_list");
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        const phoneLenMin = selectedOption.getAttribute("data-phonemin");
        const phoneLenMax = selectedOption.getAttribute("data-phonemax");
        if (machineCheck.length > 0) {
          for (let i = 0; i < machineCheck.length; i++) {
            const currCheck = machineCheck[i].value;
            if (i == machineCheck.length - 1) {
              checkboxValues += currCheck;
              break;
            }
            checkboxValues += currCheck + ", ";
          }
          const machineInput = btnForm.querySelector("input[name=type_of_machine]");
          if (machineInput) machineInput.value = checkboxValues;
          const phoneLength = phoneNum.value.length;
          if (phoneLength < parseInt(phoneLenMin) || phoneLength > parseInt(phoneLenMax)) {
            window.scrollTo({
              top: phoneNum.getBoundingClientRect().top + window.pageYOffset - 100,
              behavior: "smooth"
            });
            const phoneErr = document.querySelector(".hosp-form-phone-err");
            if (phoneErr) {
              phoneErr.style.display = "block";
              setTimeout(function () {
                phoneErr.style.display = "none";
              }, 4000);
            }
            return false;
          }
          const queryString = window.location.search;
          if (queryString != "" && queryString.indexOf("utm_source") > -1) {
            const formUtmData = getUrlVars();
            btnForm.querySelector("[name=utm_source]").value = formUtmData.utm_source || "";
            btnForm.querySelector("[name=utm_medium]").value = formUtmData.utm_medium || "";
            btnForm.querySelector("[name=utm_campaign]").value = formUtmData.utm_campaign || "";
          }
          const formData = new URLSearchParams(new FormData(btnForm)).toString();
          const submitBtn = btnForm.querySelector("[type=submit]");
          submitBtn.disabled = true;
          submitBtn.classList.add("btn--loading");
          fetch(hubspotUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "data=" + encodeURIComponent(formData)
          })
          .then(res => res.text())
          .then(ret => {
            if (!cn(ret)) {
              ret = JSON.parse(ret);
              if (!cn(ret.vid)) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "HospitalityFormSubmit",
                  formElement: formData
                });
                btnForm.style.display = "none";
                const successBlock = document.querySelector(".hosp-tayst-form-success");
                if (successBlock) {
                  successBlock.classList.remove("hide");
                  window.scrollTo({
                    top: successBlock.getBoundingClientRect().top + window.pageYOffset - 200,
                    behavior: "smooth"
                  });
                }
              } else {
                alert(ret.message);
              }
            } else {
              alert("Something went wrong! Please try again or reach out for assistance.");
            }
            submitBtn.disabled = false;
            submitBtn.classList.remove("btn--loading");
          });
        } else {
          const checkItem = btnForm.querySelector(".hosp-tayst-field[type=checkbox]:last-of-type");
          checkItem.setAttribute("required", true);
          if (!checkItem.checkValidity()) {
            setTimeout(function () {
              checkItem.removeAttribute("required");
            }, 1000);
            checkItem.reportValidity();
            return false;
          }
        }
      }
    });
    document.addEventListener("change", function(e) {
      if(e.target.matches("#country_list")){
        const countrySelect = e.target;
        const stateList = document.getElementById("state_list");
        const stateInput = document.getElementById("state_list_input");
        const options = stateList.querySelectorAll("option:not(:first-child)");
        options.forEach(opt => opt.remove());
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        const countryIso = selectedOption.getAttribute("data-iso");
        const hasStates = selectedOption.getAttribute("data-hasstates");
        const dataName = stateList.getAttribute("name");
        if (hasStates == "0") {
          stateList.classList.add("hide");
          stateList.removeAttribute("name");
          stateList.removeAttribute("required");
          stateInput.classList.remove("hide");
          stateInput.setAttribute("name", dataName);
          return;
        }
        let geoStateData = tayst.geoStateData;
        geoStateData = geoStateData.replace("countryIso",countryIso);
        fetch(geoStateData)
        .then(res => res.json())
        .then(res => {
          const outlyingArea = [];
          const provinceArr = [];
          for (let i = 0; i < res.length; i++) {
            const stateVal = res[i];
            if (!cn(stateVal)) {
              if (stateVal.type == "state" || stateVal.type == "") {
                const option = document.createElement("option");
                option.value = stateVal.name;
                option.textContent = stateVal.name;
                stateList.appendChild(option);
              } else if (stateVal.type == "province") {
                provinceArr.push(stateVal.name);
              } else {
                outlyingArea.push(stateVal.name);
              }
            }
          }
          if (provinceArr.length > 0 || outlyingArea.length > 0) {
            const remainingList = [...provinceArr, ...outlyingArea];
            for (let i = 0; i < remainingList.length; i++) {
              const option = document.createElement("option");
              option.value = remainingList[i];
              option.textContent = remainingList[i];
              stateList.appendChild(option);
            }
          }
          stateList.classList.remove("hide");
          stateList.setAttribute("name", dataName);
          stateList.setAttribute("required", true);
          stateInput.classList.add("hide");
          stateInput.removeAttribute("name");
        })
        .catch(() => {
          alert("Something went wrong! Refresh the page or reach out for assistance.");
        });
      }
    });
  }
}
new HospitalityTaystForm();